import { defineMessages } from 'react-intl';

export default defineMessages({
  beginNewThread: 'Begin New Thread'
});
